const apiUrl = process.env.REACT_APP_API_URL;
export const PostJutgePracticaIdUsuariIdMulti = async (id_practica: string, id_usuari: string, uids: string[], origen?: string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/practica/${id_practica}/usuaris/${id_usuari}/multi`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ uids, origen: origen || 'WEB_NORMAL' })
            });
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
